var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
var labelLivrareRapida='';
var availableOnSaleVariants = [];

var colorSaleLabel = '#e95144';
var borderColorSaleLabel = '#e95144';
var bgSaleLabel = '#fff';
var colorSoldOutLabel = '#d2d8db';
var borderColorSoldOutLabel = '#d2d8db';
var bgSoldOutLabel = '#fff';
var colorNewLabel = '#0066ff';
var borderColorNewLabel = '#0066ff';
var bgNewLabel = '#fff';


window.eLivrareZero=0;
// Override Settings
var boostPFSFilterConfig = {
	general: {
// 		limit: boostPFSConfig.custom.products_per_page,
//         /* Optional */
//         activeScrollToTop: true,
// //      	breakpointMobile: '1024',
//         forceCapitalizeFilterOptionValues: true,
//         rangeSliderMoneyFormat: '{{amount_no_decimals_with_comma_separator}}',
//         filterTreeMobileStyle: 'style1',
//         scrollFirstLoadLength: 10,
//         filterEverywhereDefaultSorting: 'relevance'
//       	//priceMode: "min"
        limit: 24,
        loadProductFirst: false,
        /* Optional */
        activeScrollToTop: true,
     	// breakpointMobile: '1024',
        forceCapitalizeFilterOptionValues: true,
        rangeSliderMoneyFormat: '{{amount_no_decimals_with_comma_separator}}',
        filterTreeMobileStyle: 'style1',
        scrollFirstLoadLength: 10,
        filterEverywhereDefaultSorting: 'relevance',
        showPlaceholderProductList: true,
        placeholderProductPerRow: 24,
        placeholderImageRatio: 1,
        placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-tab-3 boost-pfs-filter-grid-width-mb-1', 
      	// priceMode: "min"
	},
    custom: {
      products_per_row: 24
    }
};

var boostPFSTemplate = {
    'soldOutClass': ' sold-out',
    'saleClass': ' on-sale',
    'soldOutLabelHtml': '<span class="soldout label" {{lableStyle}}>' + boostPFSConfig.label_basic.sold_out + '</span>',
  	'saleLabelHtml': '<span class="sale label" {{lableStyle}}>{{percentSale}}</span>',
  	'newLabelHtml': '<span class="soldout label" {{lableStyle}}>' + boostPFSConfig.label_basic.new + '</span>',
    'vendorHtml': '<p class="boost-pfs-filter-product-item-vendor">{{itemVendorLabel}}</p>',

    // Grid Template
  // Georgiana - 25-01-2022 - Adaugare etichete badges inainte de titlu
    'productGridItemHtml': '<div id="product-item-{{itemId}}" class="boost-pfs-filter-product-item {{gridWidthClass}}{{soldOutClass}}{{saleClass}}">' +
                                '<div class="boost-pfs-filter-product-item-inner">' +
                                    '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-link">' +
                                        '<span class="boost-pfs-filter-product-item-image" style="padding-top: 100%; background-size: 100%; background-repeat: no-repeat; background-position: center;">' +                                
                                          '{{itemImages}}' +
                                        '</span>' +
                                        '<span class="boost-pfs-filter-product-item-label">{{itemLabels}}</span>' +
  											'{{labelLivrareRapida}}' +
                                        '<div class="boost-pfs-filter-product-bottom">' +
                                            '{{itemBadgesTags}}' +
                                            '<p class="boost-pfs-filter-product-item-title">{{itemTitle}}</p>' +
                                            '{{itemReviews}}' +                                        
                                            '{{itemVendor}}' +
                                            '{{itemPrice}}' +
  											'{{disponibilitate}}' +
  											'{{itemSwatch}}' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +
                            '</div>',
    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">←</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>←</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">→</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>→</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<label>' + boostPFSConfig.label.sorting + '</label><select class="boost-pfs-filter-filter-dropdown">{{sortingItems}}</select>',

    // Show Limit Template
    'showLimitHtml': '<label>' + boostPFSConfig.label.show_limit + '</label><select class="boost-pfs-filter-filter-dropdown">{{showLimitItems}}</select>',

    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + boostPFSConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
    'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};

(function() {
  BoostPFS.inject(this);
  Utils.slugify =  function(text) {
    if (text == null || typeof text == 'object') return '';
    if (typeof text != 'string') {
      if (typeof text.toString != 'function'){
        return '';
      }
      else {
        text = text.toString();
      }
    }
    // return text.toString().toLowerCase()
    //     .replace(/[\s\/]+/g, '-')    // Replace spaces with -
    //     .replace(/[^\w\-]+/g, '')   // Remove all non-word chars
    //     .replace(/\-\-+/g, '-')     // Replace multiple - with single -
    //     .replace(/^-+/, '')         // Trim - from start of text
    //     .replace(/-+$/, '')         // Trim - from end of text
    text = text.toLowerCase();

    // Remove Latin
    var from = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/,:;";
    var to = "aaaaaeeeeeiiiiiooooouuuuunc------";
    for (var i = 0, l = from.length; i < l; i++)
      text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));

    // Remove Czech special characters
    var specialCzechChars = 'ÁáČčĎďÉéěÍíŇňÓóŘřŠšŤťÚúůÝýŽž';
    var asciiCzechChars = 'AaCcDdEeeIiNnOoRrSsTtUuuYyZz';
    var specialCzechCharsLength = specialCzechChars.length;
    for (var j = 0; j < specialCzechCharsLength; j++) {
      text = text.replace(new RegExp(specialCzechChars.charAt(j), "g"), asciiCzechChars.charAt(j));
    }

    // Remove quotes

    var fromCustom = "ăîșțâ";
    var toCustom = "aista";
    for (var i = 0, l = fromCustom.length; i < l; i++)
      text = text.replace(new RegExp(fromCustom.charAt(i), 'g'), toCustom.charAt(i));

    text = text.replace(/'/g, '').replace(/"/g, '');
    return text.replace(/[\s\/]+/g, '-')    // Replace spaces with -
    .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-')   // Replace all special characters with -
    .replace(/\-\-+/g, '-')     // Replace multiple - with single -
    .replace(/^-+/, '')         // Trim - from start of text
    .replace(/-+$/, '')         // Trim - from end of text
  };




  var now_date_int = getDayOfYear();
  var now_year_int = (new Date()).getFullYear();

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    availableOnSaleVariants = data.variants.filter(function(variant){
      if(variant.available && variant.compare_at_price > variant.price){
      	return variant;
      }
    })

    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    var variantWithHighestDiscount;
    if(onSale){
      variantWithHighestDiscount = firstVariant
      data.variants.forEach(function(variant){
		var variantComparePrice = variant.compare_at_price !== null && variant.compare_at_price !== "" ? parseFloat(variant.compare_at_price) : null;
        var variantPrice = parseFloat(variant.price);
        if(variantComparePrice !== null && variant.available){
          var variantGlobalCompare = variantWithHighestDiscount.compare_at_price !== null && variantWithHighestDiscount.compare_at_price !== "" ? parseFloat(variantWithHighestDiscount.compare_at_price) : parseFloat(variantWithHighestDiscount.price);
          var variantGlobalPrice = parseFloat(variantWithHighestDiscount.price);
          var discountPercentageOfCurrentVariant = ((variantComparePrice - variantPrice) * 100 ) / variantComparePrice;
          var discountPercentageOfGlobalVariant = ((variantGlobalCompare - variantGlobalPrice) * 100 ) / variantGlobalCompare;
          if(discountPercentageOfCurrentVariant > discountPercentageOfGlobalVariant){
        	variantWithHighestDiscount = variant;
          }
        }
      })
    }
    data.variantWithHighestDiscount = variantWithHighestDiscount

    if (Utils.isSearchPage()) {
      data.skuVariant = data.variants.find(v => v.sku.toLowerCase() === (Globals.queryParams.q || '').trim().toLowerCase());      
    }   

    data.firstVariant=firstVariant;
    
    return data;
  }
  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);


    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Grid Width class
    itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));

    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    
    //Add Badges Tags  - Georgiana - 25-01-2022 
	itemHtml = itemHtml.replace(/{{itemBadgesTags}}/g, buildBadgesTags(data));
    
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    // Razvan 18.05.2018 disponibilitate pe produse in lista 
    itemHtml = itemHtml.replace(/{{disponibilitate}}/g, buildDisponibilitate(data));
    itemHtml = itemHtml.replace(/{{labelLivrareRapida}}/g,window.labelLivrareRapida);
    window.labelLivrareRapida='';

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add Item Swatch  	
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, buildSwatches(data)); /* boost-36349 */

    // Add reviews
    itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReviews(data));

    // Add data json
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    var itemUrl = Utils.buildProductItemUrl(data);

    if (data.skuVariant) itemUrl += "?variant=" + data.skuVariant.id;
    else if (data.variantWithHighestDiscount) itemUrl += "?variant=" + data.variantWithHighestDiscount.id;
    
    
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, itemUrl);
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildVariantSwatch(data, variantOption, isColor) {      
    var itemSwatchHtml = '';
    var optionIndex = data.options_with_values.findIndex(function(e) { return e.name == variantOption; });
    var options = data.options_with_values.filter(function(e) { return (e.name).toLowerCase() == variantOption; });
    if (typeof options[0] !== 'undefined') {
      itemSwatchHtml += '<div class="col-swatch ' + variantOption + '">';
      itemSwatchHtml += '<ul data-option-index="' + optionIndex + '" class="color options">';
      var values = '';
      for (var k in data.variants) {
        var variant = data['variants'][k];

        // Get all the name of the option color
        // Such as color, metal_color, lenses_color
        var variantOptions = variant['merged_options'];
        var temp = [variantOption];
        if (Array.isArray(variantOptions)) {
          for (var j = 0; j < variantOptions.length; j++) {
            if(variantOptions[j].indexOf(variantOption) > -1){
              temp = variantOptions[j].split(':');
            }
          }                  
        }
        var value = variant['option_' + temp[0]];
        var wrapperValue = ',' + value + ',';
        if (values.indexOf(wrapperValue) == -1 && variant.available == true) {
          var optionData = options[0]['values'].filter(function(e) { return e.title == value; });
          var imageIndex = null;
          if (typeof optionData[0] !== 'undefined')
          {
          	var imageIndex = optionData[0]['image'] - 1;
          }
          var imageVariant = '';
          if (imageIndex !== null && typeof data['images_info'][imageIndex] !== 'undefined') {
            var imageVariant = Utils.optimizeImage(data['images_info'][imageIndex].src, '360x');
          }
          if (isColor) {          
            var color = Utils.slugify(value.split(' ').pop());
            itemSwatchHtml += '<li data-option-title="' + value + '" data-href="' + imageVariant + '" class="color ' + Utils.slugify(value) + '" data-itemurl="' + Utils.buildProductItemUrl(data)  + '?variant=' + variant.id + '">';
            if (imageIndex !== null && typeof data['images_info'][imageIndex] !== 'undefined') {
              itemSwatchHtml += '<span style="background-image: url(' + Utils.optimizeImage(data['images_info'][imageIndex].src, 'icon') + ')"></span>';
            } else {
              itemSwatchHtml += '<span style="background-color: ' + color + '"></span>';
            }
            itemSwatchHtml += '</li>';
          } else {
            itemSwatchHtml += '<li data-option-title="' + value + '" data-href="' + imageVariant + '" data-itemurl="' + Utils.buildProductItemUrl(data)  + '?variant=' + variant.id + '">';
            itemSwatchHtml += '<span>' + value + '</span>';          
            itemSwatchHtml += '</li>';
          }
          values += wrapperValue;
        }

      }
      itemSwatchHtml += '</ul></div>';
      itemSwatchHtml += '<script>' +
        'jQ(\'#product-item-{{itemId}} .col-swatch.' + variantOption + ' li\').each(function(){' +
        'jQ(this).hover(function() {' +
        'var newImage = $(this).attr(\'data-href\');' +
        'var itemUrl = $(this).attr(\'data-itemurl\');' +
        'jQ(\'#product-item-{{itemId}} .boost-pfs-filter-product-item-main-image\').attr({ src: newImage, srcset: newImage }); ' +
        'jQ(\'#product-item-{{itemId}} a\').attr({ href: itemUrl }); ' +
        'return false;' +
        '});' +
        '});' +
        '</script>';    
    }  
    return itemSwatchHtml;
  }

  function buildSwatches(data) {
    var itemSwatchHtml = ''; 

    /* Color Swatch */
    itemSwatchHtml += buildVariantSwatch(data, 'culoare', true);

    /* Size Swatch */
    itemSwatchHtml += buildVariantSwatch(data, 'sezlong', false);
    itemSwatchHtml += buildVariantSwatch(data, 'brat', false);
   
    return itemSwatchHtml
  }

  function buildReviews(data) {
    // Build Labels
    var  html = '';
    if (Utils.getProductMetafield(data, 'judgeme', 'badge') !== null) {
      html = "<div style='text-align: left;' class='jdgm-widget jdgm-preview-badge' data-id='" + data.id + "'>" + Utils.getProductMetafield(data, 'judgeme', 'badge').replace(/\|/g, '"') + "</div>";
    }
    return html;
  }

  function buildGridWidthClass() {
    var gridWidthClass = '';
    // On PC
    switch (boostPFSThemeConfig.custom.products_per_row) {
      case 2:
        gridWidthClass = 'boost-pfs-filter-grid-width-2';
        break;
      case 3:
        gridWidthClass = 'boost-pfs-filter-grid-width-3';
        break;
      case 5:
        gridWidthClass = 'boost-pfs-filter-grid-width-5';
        break;
      default:
        gridWidthClass = 'boost-pfs-filter-grid-width-4';
        break;
    }

    // On Tablet
    switch (boostPFSThemeConfig.custom.products_per_row_tablet) {
      case 1:
        gridWidthClass += ' boost-pfs-filter-grid-width-tab-1';
        break;
      case 3:
        gridWidthClass += ' boost-pfs-filter-grid-width-tab-3';
        break;
      default:
        gridWidthClass += ' boost-pfs-filter-grid-width-tab-2';
        break;
    }

    // On Mobile
    switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
      case 1:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
        break;
      case 3:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
        break;
      default:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
        break;
    }
    return gridWidthClass;
  }
  
  function srcset(images, featured) {
    var method = featured ? Utils.getFeaturedImage : Utils.optimizeImage;
    
    var srcset = '';
    srcset = srcset + method.call(this, images, '260x') + ' 260w, ';
    srcset = srcset + method.call(this, images, '360x') + ' 360w';
    /* srcset = srcset + method.call(this, images, '360x') + ' 360w, ';
    srcset = srcset + method.call(this, images, '460x') + ' 460w, ';
    srcset = srcset + method.call(this, images, '560x') + ' 560w, ';
    srcset = srcset + method.call(this, images, '660x') + ' 660w, ';
    srcset = srcset + method.call(this, images, '760x') + ' 760w'; */
    return srcset;
  }

  function buildImages(data) {
    var html = '';    
    // Build Main Image

    var availableVariantsWithImages = data.variants.filter(function(variant){
      return variant.available && variant.image
    })
    if(typeof data.variantWithHighestDiscount !== "undefined" && data.variantWithHighestDiscount.image !== null){
    	availableVariantsWithImages.unshift(data.variantWithHighestDiscount)
    }

    if (data.skuVariant && data.skuVariant.image) {
      availableVariantsWithImages.unshift(data.skuVariant)
    }
    if(availableVariantsWithImages.length > 0){      
      html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
        ' alt="{{itemTitle}}" ' +
        'data-srcset="' + srcset(availableVariantsWithImages[0].image, false) + '" ' +        
        'src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" ' +
        'data-widths="[260, 360]" ' +
        'data-sizes="auto" />';
    } else {
      html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
        ' alt="{{itemTitle}}" ' +
        'data-srcset="' + srcset(images, true) + '" ' +        
        'src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" ' +
        'data-widths="[260, 360]" ' +
        'data-sizes="auto" />';
    }
    // Build Image Swap
    if (!Utils.isMobile() && !isIPad() && boostPFSThemeConfig.custom.active_image_swap) {      
      var flipImageSrcset = images.length > 1 ? srcset(images[1]['src'], false) : srcset(images, true);
      var index = 0;
      if(availableVariantsWithImages.length > 0) {
        for (var i = 0; i < data.images_info.length; i++) {
          var image = data.images_info[i];
          if (image.src == availableVariantsWithImages[0]['image']) {
            index = i + 1;
          }
        }
        if (typeof data.images_info[index] !== 'undefined') {
          flipImageSrcset = srcset(data.images_info[index]['src'], false);
        }
      }
      //console.log(index, flipImageSrcset);
      html += '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
        ' alt="{{itemTitle}}" ' +
        'data-srcset="' + flipImageSrcset + '" ' +        
        'src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" ' +
        'data-widths="[260, 360]" ' +
        'data-sizes="auto" />';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.show_vendor) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }
  
  
//Georgiana - 25-01-2022 - Adaugare etichete tip Badges 
function buildBadgesTags(data) {
    let  html = '',
    	 hasBestsellerTag = false,
         hasConfig = false,
    	 has3DTag = false,
    	 hasAmericanTag = false,
         hasOrigineItaliaTag = false,
         hasOrigineBelgiaTag = false,
         hasOrigineSpaniaTag = false,
         hasOriginePortugaliaTag = false,
         hasOrigineGermaniaTag = false,
         hasOrigineFrantaTag = false,
         hasFabricatInRoTag = false,
         hasLivrareRapidaTag = false,
    	 hasNouNiciodata = false, 
    	 hasNouMereu = false,
    	 hasNouTag = false,
         hasLivrareRapida = false,
    	 hasResigilatTag = false,
         hasBadge = false,
    	 new_day_int = '',
    	 check_new = '',
         isOutlet = false,
    	 nr_maxim_zile_pt_nou = 180; //TODO: de modificat aici cate zile sa apara NOU label pe lista
    let sku = data['variants'][0].sku;
    let transportUsor = false;
    let disponibilPipera = false;
    let nuToatePipera = false;
    let disponibilBaneasa = false;
    let nuToateBaneasa = false;
    let disponibilOutlet = false;
    let nuToateOutlet = false;
    let disponibilBrasov = false;
    let nuToateBrasov = false;
    let disponibilIasi = false;
    let nuToateIasi = false;

    // Razvan 20.10.2023 activat pe 23.10 dimineata si scos pe 31.10 seara
    //hasLivrareRapida = true;
  
    for (var i in data.tags) {  
      if (data.tags[i].toLowerCase().indexOf('transport_usor') != '-1')
        transportUsor = true ;
      if (data.tags[i].toLowerCase().indexOf('disponibil_bucuresti-pipera') != '-1')
        disponibilPipera = true ;
      if (data.tags[i].toLowerCase().indexOf('nutoate_bucuresti-pipera') != '-1')
        nuToatePipera = true ;
      if (data.tags[i].toLowerCase().indexOf('disponibil_bucuresti-baneasa') != '-1')
        disponibilBaneasa = true ;
      if (data.tags[i].toLowerCase().indexOf('nutoate_bucuresti-baneasa') != '-1')
        nuToateBaneasa = true ;
      if (data.tags[i].toLowerCase().indexOf('disponibil_outlet pipera') != '-1')
        disponibilOutlet = true ;
      if (data.tags[i].toLowerCase().indexOf('nutoate_outlet pipera') != '-1')
        nuToateOutlet = true ;
      if (data.tags[i].toLowerCase().indexOf('disponibil_brasov') != '-1')
        disponibilBrasov = true ;
      if (data.tags[i].toLowerCase().indexOf('nutoate_brasov') != '-1')
        nuToateBrasov = true ;
      if (data.tags[i].toLowerCase().indexOf('disponibil_iasi') != '-1')
        disponibilIasi = true ;
      if (data.tags[i].toLowerCase().indexOf('nutoate_iasi') != '-1')
        nuToateIasi = true ;
      if (data.tags[i].toLowerCase().indexOf('labelnou_niciodata') != '-1')
        hasNouNiciodata = true ;
      if (data.tags[i].toLowerCase().indexOf('labelnou_mereu') != '-1')
        hasNouMereu = true;  
      if (data.tags[i].indexOf('starePM_OUT') != '-1' && sku.indexOf('RES') == 0)
        hasResigilatTag = true;
      if (data.tags[i].indexOf('starePM_OUT') != '-1')
        isOutlet = true;
      if( data.tags[i].toLowerCase().includes("bestseller") )
      	hasBestsellerTag = true;
   	  if( data.tags[i].toLowerCase().includes("vezi in 3d") )
      	has3DTag = true;
      if( data.tags[i].toLowerCase().includes("produs configurabil") )
      	hasConfig = true;
      if( data.tags[i].toLowerCase().includes("tagcros_configurabil-da") )
      	hasConfig = true;
      if( data.tags[i].toLowerCase().includes("tagcros_origine-italia") )
      	hasOrigineItaliaTag = true;
      if( data.tags[i].toLowerCase().includes("tagcros_origine-belgia") )
      	hasOrigineBelgiaTag = true;
      if( data.tags[i].toLowerCase().includes("tagcros_origine-spania") )
      	hasOrigineSpaniaTag = true;
      if( data.tags[i].toLowerCase().includes("tagcros_origine-portugalia") )
      	hasOriginePortugaliaTag = true;
      if( data.tags[i].toLowerCase().includes("tagcros_origine-germania") )
      	hasOrigineGermaniaTag = true;
      if( data.tags[i].toLowerCase().includes("tagcros_origine-franta") )
      	hasOrigineFrantaTag = true;
      // if( data.tags[i].toLowerCase().includes("tagcros_stil-american") )
      // 	hasAmericanTag = true;
      if( data.tags[i].toLowerCase().includes("badge_") || data.tags[i].toLowerCase().includes("badgetext_") )
        hasBadge = true;
    }

      
  	if( data.tags.includes("Fabricat în România") )
      	hasFabricatInRoTag = true;
  
    if (hasNouMereu) {  
		hasNouTag = true;
    } 
    else if (hasNouNiciodata) {
      	hasNouTag = false;
    }
    else {
      const pub_date_int = getDayOfYear(data.created_at); 
      const pub_year_int = (new Date(data.created_at)).getFullYear();
      if (now_year_int == pub_year_int) {
        new_day_int = boostPFSConfig.custom.new_day;
        check_new = now_date_int - pub_date_int;
        if (check_new >= 0 && check_new <= nr_maxim_zile_pt_nou) {
			hasNouTag = true;
        }
      } 
      else {
        check_new = now_date_int + 365 * ( now_year_int - pub_year_int ) - pub_date_int;
        if (check_new >= 0 && check_new <= nr_maxim_zile_pt_nou) {
          hasNouTag = true;
        }
      }
    } 
      //Razvan - 03.03.2021 adaug badge Livrare Rapida pentru T&G pe stoc https://app.asana.com/0/634482690143506/1200010871656864
    if (data.tags.includes('PM_VCINCA') && data.tags.includes('Collection_Terasa si Gradina') && data.tags.includes('Disponibilitate_În stoc'))
    {
      	hasLivrareRapidaTag = true;
    }
      
    let hasOtherBadge = false;
  // 05.11.2023 Anulat Livrare Rapida pe perioada BF 1/2 (scos 04.12.2023)
    if ((disponibilPipera && transportUsor && !nuToatePipera) || (disponibilBaneasa && transportUsor && !nuToateBaneasa) || (disponibilOutlet && transportUsor && !nuToateOutlet))
    {
      hasOtherBadge = true;
    }
  
  
    if( hasNouTag|| hasResigilatTag || hasFabricatInRoTag || hasLivrareRapidaTag || hasLivrareRapida || hasBadge || hasOtherBadge || hasConfig || hasAmericanTag || hasOrigineItaliaTag || hasOrigineBelgiaTag || hasOrigineSpaniaTag || hasOriginePortugaliaTag || hasOrigineGermaniaTag || hasOrigineFrantaTag){
    	html += "<div class='adec-lista-etichete colectie'>";  
  		
      	var trebuieBr = 0;

        if (hasLivrareRapida)
        {
          html += "<br><div class='adec-promo-badge-text-livrarea-standard-gratuita'>LIVRAREA STANDARD GRATUITĂ</div>";
          trebuieBr = 1;
        }
      
    	//adaug badge-uri pentru tag-urile care incep cu badge_
    	for (var i in data.tags) {
      		if (data.tags[i].indexOf('badgeText_') == '0'){
        	theBadge=data.tags[i].substr(10);
            if (theBadge == "5% Extra Reducere la comenzi peste 300 lei cu produse OUTLET")
            {
              theBadge = "";
            }
        	theBadgeHandle=theBadge.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        	html += "<div class='adec-promo-badge-text adec-promo-badge-text-" + theBadgeHandle + "'>" + theBadge + "</div>";
        	trebuieBr = 1;
      		}
      
    	}  
        theBadge = "";

      // 05.11.2023 Anulat Livrare Rapida pe perioada BF 2/2

        if ((disponibilPipera && transportUsor && !nuToatePipera) || (disponibilBaneasa && transportUsor && !nuToateBaneasa) || (disponibilOutlet && transportUsor && !nuToateOutlet))
        {
          if (!theBadge)
          {
            theBadge = "Livrare rapidă 3H în ";
          }
          else
          {
            theBadge = theBadge + ", ";
          }
          theBadge = theBadge + "București";  
        }
        if (disponibilBrasov && transportUsor && !nuToateBrasov) 
        {
          if (!theBadge)
          {
            theBadge = "Livrare rapidă 3H în ";
          }
          else
          {
            theBadge = theBadge + ", ";
          }
          theBadge = theBadge + "Brașov";  
        }
        if (disponibilIasi && transportUsor && !nuToateIasi) 
        {
          if (!theBadge)
          {
            theBadge = "Livrare rapidă 3H în ";
          }
          else
          {
            theBadge = theBadge + ", ";
          }
          theBadge = theBadge + "Iași";  
        }


        
        if (theBadge)
        {
          theBadgeHandle=theBadge.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
          html += "<div class='adec-promo-badge-text adec-promo-badge-text-" + theBadgeHandle + "'>" + theBadge + "</div>";
          trebuieBr = 1;
        }
    	if (trebuieBr == 1){
      		html+="<br>";
    	}
      
    	if( hasNouTag && !hasResigilatTag && !isOutlet){
      	html += "<div class='adec-eticheta-nou'><span class='badge-label'>Produs Nou</span> Nou</div>";
    	}
    	if( hasBestsellerTag ){      	
		html += "<div class='adec-eticheta-bestseller' ><span class='badge-label'>Unul din cele mai bine vândute produse</span>Bestseller</div>";
    	}
        if( hasOrigineItaliaTag ){      	
		html += "<div class='adec-eticheta-origine-italia' ><span class='badge-label'>Fabricat în Italia</span></div>";
    	}
        if( hasOrigineBelgiaTag ){      	
		html += "<div class='adec-eticheta-origine-belgia' ><span class='badge-label'>Fabricat în Belgia</span></div>";
    	}
        if( hasOrigineSpaniaTag ){      	
		html += "<div class='adec-eticheta-origine-spania' ><span class='badge-label'>Fabricat în Spania</span></div>";
    	}
        if( hasOriginePortugaliaTag ){      	
		html += "<div class='adec-eticheta-origine-portugalia' ><span class='badge-label'>Fabricat în Portugalia</span></div>";
    	}
        if( hasOrigineGermaniaTag ){      	
		html += "<div class='adec-eticheta-origine-germania' ><span class='badge-label'>Fabricat în Germania</span></div>";
    	}
        if( hasOrigineFrantaTag ){      	
		html += "<div class='adec-eticheta-origine-franta' ><span class='badge-label'>Fabricat în Franta</span></div>";
    	}
  //   	if( hasAmericanTag ){      	
		// html += "<div class='adec-eticheta-stil-american' ><span class='badge-label'>Confort american la tine acasă</span>Stil American</div>";
  //   	}
    	if( hasResigilatTag ){
      	html += "<div class='adec-eticheta-resigilat' ><span class='badge-label'>Produsul este Resigilat</span>Resigilat</div>";
    	}
    	if( hasFabricatInRoTag){
		html += "<div class='adec-eticheta-fabricat-in-ro' ><span class='badge-label'>Fabricat cu mândrie de noi în România</span></div>";
    	}
    	if( hasLivrareRapidaTag ){
      	html += "<div class='adec-eticheta-livrare-rapida' ><span class='badge-label'>Produs livrat în 24-48 ore</span><svg class='truck' x='0px' y='0px' viewBox='0 0 640 512'><path  d='M621.3,237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3,32,0,46.3,0,64v336  c0,44.2,35.8,80,80,80c26.3,0,49.4-12.9,64-32.4c14.6,19.6,37.7,32.4,64,32.4c44.2,0,80-35.8,80-80c0-5.5-0.6-10.8-1.6-16h163.2  c-1.1,5.2-1.6,10.5-1.6,16c0,44.2,35.8,80,80,80s80-35.8,80-80c0-5.5-0.6-10.8-1.6-16H624c8.8,0,16-7.2,16-16v-85.5  C640,265.5,633.3,249.3,621.3,237.3z M80,432c-17.6,0-32-14.4-32-32s14.4-32,32-32s32,14.4,32,32S97.6,432,80,432z M208,432  c-17.6,0-32-14.4-32-32s14.4-32,32-32s32,14.4,32,32S225.6,432,208,432z M480,208h37.5c4.3,0,8.3,1.7,11.3,4.7l43.3,43.3H480V208z   M528,432c-17.6,0-32-14.4-32-32s14.4-32,32-32c17.6,0,32,14.4,32,32S545.6,432,528,432z'></path></svg>24 - 48 ore</div>";
    	}
    	if( has3DTag ){
		html += "<div class='adec-eticheta-vezi-in-3d'><span class='badge-label'>Vezi produsul la tine în casă</span>Vezi în 3D</div>";
    	}
        if( hasConfig ){
		html += "<div class='adec-eticheta-configurabil'>Configurabil</div>";
    	}

      
     
//     	var trebuieBr = 0;
//     	//adaug badge-uri pentru tag-urile care incep cu badge_
//     	for (var i in data.tags) {
//       		if (data.tags[i].indexOf('badgeText_') == '0'){
//         	theBadge=data.tags[i].substr(10);
//         	theBadgeHandle=theBadge.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
//         	html += "<div class='adec-promo-badge-text adec-promo-badge-text-" + theBadgeHandle + "'>" + theBadge + "</div>";
//         	trebuieBr = 1;
//       		}
      
//     	}    
//     	if (trebuieBr == 1){
//       		html+="<br>";
//     	}      
        for (var i in data.tags) {
      
      		if (data.tags[i].indexOf('badge_') == '0'){
        		theBadge=data.tags[i].substr(6);
        		theBadgeHandle=theBadge.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			//Georgiana - 25-01-2022 - Etichete personalizate tip badge
        	if(!data.tags[i].toLowerCase().includes("bestseller") && !data.tags[i].toLowerCase().includes("vezi in 3d") && !data.tags[i].toLowerCase().includes("produs configurabil") &&  !data.tags[i].toLowerCase().includes("produs resigilat")){
        		html += "<div class='adec-promo-badge adec-promo-badge-" + theBadgeHandle + "'>" + theBadge + "</div>";
        	}
      		}
    	}
    	html += "</div>";  
    }
  

    //Razvan 23.06.2023 IMB badge produs in adec_promotii_imb_active?
  if(typeof adec_promotii_imb_active !== 'undefined') {
  //console.log(adec_promotii_imb_active);
    let lines = adec_promotii_imb_active.split(`
`); // split the string into lines
    if (lines.length > 0)
    {
      for(let i = 0; i < lines.length; i++) {
          let line = lines[i]; 
        //console.log(line);
          let elements = line.split('|'); // split the line into elements by '|'
          if (elements.length == 6)
          {
            
            let ids = elements[4].split(',');
            if(elements[3] === 'Collections') { 
              for(let j = 0; j < ids.length; j++) {
                //console.log(ids[j]);
                //console.log(data.collections);
                for (let k=0; k < data.collections.length; k++)
                {
                  
                  if (ids[j] == data.collections[k].id) {
                    html += "<div class='adec-imb-colectie'>Promoție: " + elements[5] + "</div>";
                  }
                }
              }
            }
          }
      }
    }
  }
  
   return html;
}
// End Georgiana - 25-01-2022 
function buildPrice(data) {
    //console.log(data);
  var um = '';
   for (var i in data.tags) {
      if (data.tags[i].indexOf('UnitateMasura_') == '0')
      {
        um = "/" + data.tags[i].substr(14);
        break;
      }	
    }
    var html = '';
    if (boostPFSThemeConfig.custom.show_price) {
      //RAZVAN 05.06.2018 DE LA si pt produse cu reducere
      var price = data.price_min;
      window.price=price;
      var price_var = 99999999;
      var compare_at_price_var=0;
      var nrVariante=0;
      var nrPreturiDiferite=0;
      var compare_at_price = data.compare_at_price_min;
      for (var k = 0; k < data.variants.length; k++) {
        var variant = data['variants'][k];
        if (variant.inventory_quantity > 0 || variant.inventory_policy == 'continue') {
          if (price_var<variant.price) {
            nrPreturiDiferite++;
          }
          if (price_var>variant.price) {
            nrPreturiDiferite++;
            price_var = variant.price;
            compare_at_price_var = variant.compare_at_price;
            if (compare_at_price_var==0)
              compare_at_price_var=price_var;
          }
          nrVariante++;
        }
      }
      if (price_var<99999999)
      {
        price=price_var;
        window.price=price;
        compare_at_price=compare_at_price_var;
      }

      /* if (data.skuVariant) {
        price= parseFloat(data.skuVariant.price);
        window.price=price;
        compare_at_price= parseFloat(data.skuVariant.compare_at_price);
      } */

      html = '<p class="boost-pfs-filter-product-item-price">';
      if (onSale && compare_at_price>price) {
        
        //END RAZVAN 05.06.2018 DE LA si pt produse cu reducere
        
        
        var adecPretRecomandat=99999999;
        if (data.metafields && data.metafields.length>0)
        {

          for (index = 0; index < data.metafields.length; ++index) {
            if (data.metafields[index].value) {
              if (data.metafields[index].id == data.firstVariant.id) { 
                if (data.metafields[index].key=='pret_recomandat') {
                   adecPretRecomandatAsta=parseInt(data.metafields[index].value.replace(".",""));
                  if (adecPretRecomandatAsta>compare_at_price && adecPretRecomandatAsta<adecPretRecomandat)
                  {
                    adecPretRecomandat=adecPretRecomandatAsta;
                  }
                }
              }
            }    
          }
        }
        
        if ((adecPretRecomandat<99999999 && adecPretRecomandat>0) )
        {
          html += 'PRP:';
          if (priceVaries  && (nrPreturiDiferite > 1)) {
            html += ' De la'; 
          }
          
          html += ' <s>' + adecPretRecomandat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' lei' + um + '</s> <br>';
        }
        if (priceVaries  && (nrPreturiDiferite > 1)) {
          html += 'De la' + ' '; 
        }
        html += '<s>' + compare_at_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' lei' + um + '</s> &nbsp;';
        html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(price).trim() + um + '</span>';
      } else {
        var adecPretRecomandat=99999999;
        if (data.metafields && data.metafields.length>0)
        {

          for (index = 0; index < data.metafields.length; ++index) {
            if (data.metafields[index].value) {
              if (data.metafields[index].id == data.firstVariant.id) { 
                if (data.metafields[index].key=='pret_recomandat') {
                   adecPretRecomandatAsta=parseInt(data.metafields[index].value.replace(".",""));
                  if (adecPretRecomandatAsta>compare_at_price && adecPretRecomandatAsta<adecPretRecomandat)
                  {
                    adecPretRecomandat=adecPretRecomandatAsta;
                  }
                }
              }
            }    
          }
        }
        
        if ((adecPretRecomandat<99999999 && adecPretRecomandat>0) )
        {
          html += 'PRP:';
          if (priceVaries  && (nrPreturiDiferite > 1)) {
            html += ' De la'; 
          }
          html += ' <s>' + adecPretRecomandat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' lei' + um + '</s> <br>';
        }
        if (priceVaries  && (nrPreturiDiferite > 1)) {
          html += 'De la' + ' '; //RAZVAN 04.06.2018 'De la' in loc de (boostPFSConfig.label_basic.from)
        }
        html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(price).trim() + um + '</span>';
      }
      html += '</p>';
    }
    return html;
  }
	
  
  
  // Razvan 18.05.2018 disponibilitate pe produse in lista 
  function buildDisponibilitate(data) {
    var html='';
	
    //Razvan 20.06.2021 badge Livrarea Gratuita
   		// html += "<div class='adec-promo-badge'>LIVRARE GRATIS</div>";
    
    let hasLivrareRapidaTag = false;
    
    //03.03.2021 adaug badge Livrare Rapida pentru T&G pe stoc https://app.asana.com/0/634482690143506/1200010871656864
    // Georgiana - 25-01-2022 - Badge actualizat cofnorm https://app.asana.com/0/0/1201692435810627/f
    if (data.tags.includes('PM_VCINCA') && data.tags.includes('Collection_Terasa si Gradina') && data.tags.includes('Disponibilitate_În stoc')){
     	hasLivrareRapidaTag = true;
    }
    
    if ( window.eLivrareZero == 1 ) {
      html += '<div class="adec-livrarea-gratis">Livrarea GRATIS</div>';
    }

    // console.log(data.metafields);
    if (data.metafields && data.metafields.length>0)
    {
      adecTextDisp='';
      adecTLMin=999;
      adecTLMax=999;
      for (index = 0; index < data.metafields.length; ++index) {
        if (data.metafields[index].id == data.firstVariant.id) {
          if (data.metafields[index].value) {
            if (data.metafields[index].value.indexOf('|') > -1)
            {
              adecDisp=data.metafields[index].value.split("|");
              if (adecTextDisp=='')
              {
                adecTextDisp=adecDisp[0];
                adecTLMin=parseInt(adecDisp[1]);
                adecTLMax=parseInt(adecDisp[2]);
              }
              else
              {
                if (adecDisp[0]=='În stoc' || adecDisp[0]=='În stoc. Disponibil doar online')
                  adecTextDisp=adecDisp[0];
                if (adecDisp[1] && parseInt(adecDisp[1])<adecTLMin)
                  adecTLMin=parseInt(adecDisp[1]);
                if (adecDisp[2] && parseInt(adecDisp[2])<adecTLMax)
                  adecTLMax=parseInt(adecDisp[2]);
              }
            }
            
          }    
        }
      }
      //[firstVariant['id']]
      //Desfac in partile componente
      if (adecTextDisp!='')
      {
        LivrareRapidaBucurestiIlfov=0;
        LivrareRapida8Orase=0;
        if ((adecTextDisp=="În stoc"  || adecTextDisp=="În stoc. Disponibil doar online"))
        {
          for (var i in data.tags) {
            if (data.tags[i].indexOf('LivrareRapidaBucurestiIlfov') != '-1')
            {
              LivrareRapidaBucurestiIlfov=1;
            }
            if (data.tags[i].indexOf('LivrareRapida8Orase') != '-1')
            {
              LivrareRapida8Orase=1;
            }
          }
        }
        // RAZVAN 11.05.2020 scos de tot tratamentul separat pt produse in stoc
        // RAZVAN 16.03.2020 https://app.asana.com/0/0/1166651246200338/f
        adecTextDispFaraOnline = adecTextDisp.replace(". Disponibil doar online", "");
        if( hasLivrareRapidaTag )
        adecTextDispDoarOnline = "Disponibil doar online";
        else
          adecTextDispDoarOnline = "<br>Disponibil doar online";
        if (adecTextDispFaraOnline == adecTextDisp)
          adecTextDispDoarOnline = "";

        
        if( hasLivrareRapidaTag ){
          html += "<div class='adec-lista-disponibilitate livrare-rapida'>" + adecTextDispFaraOnline + ". Livrarea în 24 - 48 ore</div>";
          html += "<div class='adec-lista-disponibilitate'>" + adecTextDispDoarOnline + "</div>";
        }
        else if(adecTLMin==adecTLMax)
          html += '<div class="adec-lista-disponibilitate">' + adecTextDispFaraOnline + ': livrarea în ' + adecTLMin + ' zile lucrătoare (estimativ)' + adecTextDispDoarOnline + '</div>';
        else
          html += '<div class="adec-lista-disponibilitate">' + adecTextDispFaraOnline + ': livrarea în ' + adecTLMin + '-' + adecTLMax + ' zile lucrătoare (estimativ)' + adecTextDispDoarOnline + '</div>';
      }
    }
    return html;
  }  

  function isInt(value) {
    var newVal = parseFloat(value);
    return !!newVal || newVal === 0; // !isNaN(value) && (function(x) { return (x | 0) === x; })(parseFloat(value))
  }

function buildLabels(data) {
    // Build Sold out label
    var soldOutLabel = '';
   //console.log(data);

    //RAZVAN 30.05.2018 labels
	//Georgiana - 25-01-2022 - Am scos tot ce tine de labelurile de Nou si Fabricat in Romania - s-au adaugat ca badge-uri
    // Build notnew Labels

    var procent_minim_reducere_pt_label=5; //%

    var eVesela=0, starePM_LIC=0, starePM_SL=0, starePM_OUT=0, economieSet=0, eAniversare=0;
    window.eLivrareZero=0;

    
    // Razvan 23.11.2021 Super Pret
	window.ePromo=0;
    window.eCodPromo=0;
  
     for (var i in data.tags) {     
       /* 20.11.2023 scos labels campania aniversare
       if (data.tags[i].indexOf('TagCros_Campanie-2023_REDUCERI_ANIVERSARE') != '-1')
       {
        eAniversare=1;
        //console.log("E aniversare");         
       }
       */
 
//geos       if (data.tags[i].indexOf('starePM_LIC') != '-1')
//         starePM_LIC=1;
//       if (data.tags[i].indexOf('starePM_SL') != '-1')
//         starePM_SL=1;
      if (data.tags[i].indexOf('starePM_OUT') != '-1')
        starePM_OUT=1;
      if (data.tags[i].indexOf('economieSet_') != '-1')
        economieSet=data.tags[i].split('_')[1].replace(".00", "");
      if (data.tags[i].indexOf('Collection_Vesela ') != '-1')
        eVesela=1;
      if (data.tags[i].indexOf('livrare_0') != '-1')
        window.eLivrareZero=1;

      
       // Razvan 23.11.2021 Super Pret
      if (data.tags[i].indexOf('LabelPromo_') != '-1')
      {
        window.eCodPromo=1;
        window.procentCodPromo=data.tags[i].split("_").pop();
        //console.log(window.procentCodPromo);
      }
      if (data.tags[i]=='Promo')
        window.ePromo=1;
    }

    if (starePM_OUT==1)
      eAniversare=0;
  
    var saleLabel = '',
    label_style = "adec-reducere"; //geos "adec-promotie";

    Number.isInteger = Number.isInteger || function(value) {
      return typeof value === "number" &&
        isFinite(value) &&
        Math.floor(value) === value;
    };
    if(availableOnSaleVariants.length > 0){
    	var newPercent = Math.floor((availableOnSaleVariants[0].compare_at_price - availableOnSaleVariants[0].price)*100 / availableOnSaleVariants[0].compare_at_price);
    }
    if (boostPFSConfig.custom.show_sale_label && availableOnSaleVariants.length > 0 && newPercent >= procent_minim_reducere_pt_label) {

      if (starePM_OUT) label_style="adec-outlet";

        
        //31.10.2022 Razvan diferentiere labels Black Friday vs Reducere in functie de pret_vanzare_anterior din metafield
        //var eBF=1; //va fi 0 daca prima varianta redusa are pret_vanzare_anterior>0 si pret_vanzare_anterior<compare_at_price
        var eBF=0; //20.11.2023 scoate linia de deasupra si pune-o pe asta dupa BF 2023

        var adecPretVanzareAnteriorAsta=0;
        
      
        var adecPretRecomandat=0;
        
        if (data.metafields && data.metafields.length>0)
        {
          //console.log(availableOnSaleVariants[0].id);
          //console.log(data.metafields);
          for (index = 0; index < data.metafields.length; ++index) {
            // Georgiana - 13-07-2022 - corectat, pentru ca nu functiona tag-ul de Extrareducere. Nu se compara id cu id. 
            // if (data.metafields[index].namespace == availableOnSaleVariants[0].id) {
            if (data.metafields[index].id == availableOnSaleVariants[0].id) {
              if (data.metafields[index].value) {
                if (data.metafields[index].key=='pret_recomandat') {
                   adecPretRecomandatAsta=parseInt(data.metafields[index].value.replace(".",""));
                  if (adecPretRecomandatAsta>availableOnSaleVariants[0].compare_at_price)
                  {
                    adecPretRecomandat=adecPretRecomandatAsta;
                    
                  }
                }
/* 20.11.2023 Razvan gata cu BF 
                //31.10.2022 Razvan diferentiere labels Black Friday vs Reducere in functie de pret_vanzare_anterior din metafield (care e pretul de imediat inainte de BF)
                if (data.metafields[index].key=='pret_vanzare_anterior') {
                  var adecPretVanzareAnteriorText=data.metafields[index].value;
                  //al doilea sau al treilea caracter din capat e punct? inseamna ca e virgula decimala
                  var decpoint1 = adecPretVanzareAnteriorText.charAt(adecPretVanzareAnteriorText.length - 3);
                  var decpoint2 = adecPretVanzareAnteriorText.charAt(adecPretVanzareAnteriorText.length - 2);
                  if (decpoint1=="." || decpoint2==".")
                  {
                    adecPretVanzareAnteriorAsta=Math.round(adecPretVanzareAnteriorText); //pe stil 1324.00 sau 23.5
                  }
                  else
                  {
                    adecPretVanzareAnteriorAsta=Math.round(adecPretVanzareAnteriorText.replace(".","")); //pe stil 1.324
                  }
                  //console.log("Pret vanzare anterior BF: "+adecPretVanzareAnteriorAsta);
                  //console.log("Pret vanzare curent: "+Math.round(availableOnSaleVariants[0].price));
                  if (adecPretVanzareAnteriorAsta>0 && adecPretVanzareAnteriorAsta <= Math.floor(availableOnSaleVariants[0].price))
                  {
                    eBF=0;
                  } 
                  
                }
 20.11.2023 sfarsit scoate la BF*/
      
                
              }   
              
            }
          }
          //console.log("E BF? " + eBF);
          
        }

      if (eBF==1)
        eAniversare=0;
      
      if (adecPretRecomandat>0)
      {
        label_style="adec-extra-reducere";
      }

      
      
      var price = data.price_min;
      window.price=price;
      var price_var = 99999999;
      var compare_at_price_var=0;
      var nrVariante=0;
      var compare_at_price = availableOnSaleVariants[0].compare_at_price;
      var au_toate_variantele_reducere = true; //Razvan 01.09.2020 https://app.asana.com/0/0/1191403384120841/f adaugat ca sa scoatem label de reducere pe produsele la care exista vreo varianta fara reducere

      for (var k = 0; k < data.variants.length; k++) {
        var variant = data['variants'][k];
        if (variant.price>0 && (variant.inventory_quantity > 0 || variant.inventory_policy == 'continue')) {
          if (price_var>variant.price) {
            price_var = variant.price;
            if (isInt(variant.compare_at_price))
            {
              compare_at_price_var = variant.compare_at_price;
              if (compare_at_price_var==0)
                compare_at_price_var=price_var;
              if (compare_at_price_var <= price_var)
                au_toate_variantele_reducere=false;
            }
            else
            {
              compare_at_price_var=price_var;
              au_toate_variantele_reducere = false;
            }
          }
          else
          {
            if (isInt(variant.compare_at_price))
            {
              if (variant.compare_at_price <= variant.price)
                au_toate_variantele_reducere=false;
            }
            else
            {
              au_toate_variantele_reducere = false;
            }
          }
          nrVariante++;
        }
      }

      if (price_var<99999999) {
        price=price_var;
        window.price=price;
        compare_at_price=compare_at_price_var;
      }

      reducerea = (compare_at_price-price)*100 / compare_at_price;
      diferenta = reducerea - Math.floor(reducerea);
      var pragRotunjire = 0.85;
      if (price < 20000)
        pragRotunjire = 0.5;
      if (diferenta >= pragRotunjire)
        reducerea = Math.round(reducerea);
      else
        reducerea = Math.floor(reducerea);
      
      //vechiul_nr= newPercent; //asta e calculat de app
      if (au_toate_variantele_reducere && Number.isInteger(reducerea) && reducerea<100 && reducerea>0) {        
        data.percent_sale_min=reducerea;
        saleLabel='<div class="product-labels labels-rectangular list-label';
        // if (window.eRo==1) saleLabel = saleLabel + ' ro';
        if (eBF==1 && label_style!="adec-outlet") label_style = label_style + " bf";
        if (eAniversare==1) saleLabel = saleLabel + ' aniversare';
        saleLabel = saleLabel + '"><span class="' + label_style + ' list-label">' + data.percent_sale_min + '</span></div>';
      }
    }

  
    // Razvan 23-26.11.2021 Super Pret si Cod Promo
    if (saleLabel=='' && window.eCodPromo)
    { 
      label_style="cod-promo";
      saleLabel='<div class="product-labels labels-rectangular list-label';
      //if (window.eRo==1) saleLabel = saleLabel + ' ro';
      if (eBF==1) label_style = label_style + " bf";
      if (eAniversare==1) saleLabel = saleLabel + ' aniversare';
      saleLabel = saleLabel + '"><span class="' + label_style + ' list-label">' + window.procentCodPromo + '</span></div>';
    }
    if (saleLabel=='' && window.ePromo)
    { 
      //Razvan 5.07.2023 Verific daca are PRP, pentru a pune Super Pret doar pe cele cu PRP, nu si pe cele cu voucher cadou (ambele au tag Promo) https://app.asana.com/0/0/1204933523368193/f
      var adecPretRecomandat=0;
      if (data.metafields && data.metafields.length>0)
      {
        for (index = 0; index < data.metafields.length; ++index) {
          if (data.metafields[index].value) {
            if (data.metafields[index].id == data.firstVariant.id) { 
              if (data.metafields[index].key=='pret_recomandat') {
                 adecPretRecomandatAsta=parseInt(data.metafields[index].value.replace(".",""));
                if (adecPretRecomandatAsta>0)
                {
                  adecPretRecomandat=adecPretRecomandatAsta;
                  break;
                }
              }
            }
          }    
        }
      }
  
      //console.log(adecPretRecomandat);
      if (adecPretRecomandat>0)
      {
        label_style="super-pret";
        
        saleLabel='<div class="product-labels labels-rectangular list-label';
          //if (window.eRo==1) saleLabel = saleLabel + ' ro';
        //if (eBF==1) label_style = label_style + " bf"; //super-pret nu are BF
        if (eAniversare==1) saleLabel = saleLabel + ' aniversare';
        saleLabel = saleLabel + '"><span class="' + label_style + ' list-label"> </span></div>';
      }
    }

    //economieSet
    if (saleLabel=='' && economieSet!=0 && eVesela!=0 )
    {
      var clasaSpeciala="";
      if (economieSet>999)
      {  
        clasaSpeciala=" avantajset_4cifre";
      }
      saleLabel='<div class="product-labels labels-rectangular list-label';
      saleLabel = saleLabel + '"><span class="avantajset list-label' + clasaSpeciala +'">' + economieSet + '</span></div>';
      newLabels='';
    }
    //END Razvan 30.05.2018 Labels


    // Build Labels
    var html = soldOutLabel + saleLabel ;
    return html;
  }

  function getDayOfYear(date) {
    var now = date != null ? new Date(date) : new Date();
    var start = new Date(now.getFullYear(), 0, 0);
    var diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
    var oneDay = 1000 * 60 * 60 * 24;
    var day = Math.floor(diff / oneDay);

    return day;
  }  

  function isIPad() {
    return navigator.userAgent.match(/iPad/i); 
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }
    if (Settings.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
  };
  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {				
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function() {
    jQ(Selector.topSorting).html(this.compileTemplate());

    var paramSort = Globals.queryParams.sort || '';
    // Set current value
    jQ(Selector.topSorting + ' select').val(paramSort);
  }


  /************************** END BUILD TOOLBAR **************************/
  jQ(document).on('lazyloaded', '.boost-pfs-filter-product-item-main-image', function() {
    if (!Utils.isMobile() && !isIPad()) {        
      var imageContainer = jQ(this).parent();
      imageContainer.css('width', '100%').css('height', jQ(this).height());
    }
  });

  function buildImageSwap() {
    jQ('.boost-pfs-filter-product-item-image').each(function() {
      jQ(this).children('img').css({
        'position': 'absolute',
        'top': 0,
        'left': 0,
        'width': '100%'
      })
    });
    jQ('.boost-pfs-filter-product-item-main-image').hover(function() {
      jQ(this).css('opacity', 0);
      jQ(this).siblings().show();
    }, function() {
      jQ(this).css('opacity', 1);
      jQ(this).siblings().hide();
    });
  }

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {		
    if (!data) data = this.data;

    // Build Image Swap
    if (!Utils.isMobile() && !isIPad() && boostPFSConfig.custom.active_image_swap) buildImageSwap();

    //         if (Utils.isMobile() || isIPad()) {
    //             setTimeout(function(){ jQ(".boost-pfs-filter-product-item-image img").each(function(e) { var x = jQ(this).attr('src') + "3"; jQ(this).attr('src',x); }); }, 200);      
    //             setTimeout(function(){ jQ(".boost-pfs-filter-product-item-image img").each(function(e) { var x = jQ(this).attr('src') + "3"; jQ(this).attr('src',x); }); }, 2000);      
    //         }
  };

  // Build additional elements
  var customPageTitle = ''	    
  Filter.prototype.afterRender = function(data , eventType) {	
    if (!data) data = this.data;
	if (!eventType) eventType = this.eventType;
    
    customPageTitle = '';
    if (Globals.queryParams.tag) {  
      if(typeof Globals.queryParams.tag === "string"){
        Globals.queryParams.tag = customSlugify(Globals.queryParams.tag)
      }
       var subcollection = false;
      if (data.filter) subcollection = data.filter.options.find(function(opt) { return opt.filterType === 'collection' && opt.displayType === 'multi_level_collections'; });
      if (subcollection) {
        for (var i = 0; i < subcollection.values.length; i++) {
          var value = subcollection.values[i];
          var found = false;

          for (var j = 0; j < value.tags.length; j++) {
            var tag = value.tags[j];
            tag.tag = customSlugify(tag.tag)

            // if (tag.tag == Globals.queryParams.tag[0].toLowerCase()) { // Schimbare tag handles - 06.12.2022
            if (tag.tag == customSlugify(Globals.queryParams.tag[0])) {
              //console.log(tag);
              //console.log(Globals.queryParams.tag)
              customPageTitle = tag.displayName + ' | Cumpara online - Mobexpert';
              // Razvan 05.02.2022 comentata la sugestia lui Mihai Aperghis vezi mail //document.title = customPageTitle;
             // console.log(tag)
              jQ('.entry-title').html(tag.displayName);
              /* Vertify pentru Black Friday
              if (tag.tag == 'promo') {
                jQ('.entry-title').html(tag.displayName + ' Black Friday');
              } else {
                jQ('.entry-title').html(tag.displayName);
              }
              */
              found = true;
              break;
            }
          }
          if (found) break;
        };
      }
    }

    if(Utils.isTagPage() && boostPFSAppConfig.currentTagRemoveLink != ''){
      if(jQ(".boost-custom-collection-tag a").length){
        var collectionUrl = boostPFSAppConfig.collectionUrl
        var queryParameters = window.location.search;
        jQ(".boost-custom-collection-tag a").attr("href" , collectionUrl + queryParameters)
      }
    }
    
    // #boost-121712: customize tag refine item
    
	if(Utils.isTagPage() && boostPFSAppConfig.currentTagRemoveLink != ''){
      if (boostPFSConfig.general.current_tags[0]) {
        var tagHtml = boostPFSAppConfig.currentTagRemoveLink;
        // var selector = 'a.boost-pfs-filter-button[href*="' + boostPFSConfig.general.current_tags[0].toLowerCase() + '"] .boost-pfs-filter-option-value'; // Schimbare tag handles - 06.12.2022
        //console.log('test ' + customSlugify(boostPFSConfig.general.current_tags[0]));
        var selector = 'a.boost-pfs-filter-button[href*="' + customSlugify(boostPFSConfig.general.current_tags[0]) + '"] .boost-pfs-filter-option-value';
        var desc = jQ(selector).text()
        var value = desc || boostPFSConfig.general.current_tags.join(' ');
        tagHtml = tagHtml.replace(/{{ current_tags }}/g, value);
        var currentRefineHtml =  jQ('.boost-pfs-filter-refine-by-items').html().toString();
        // console.log(tagHtml)
        // console.log(currentRefineHtml)
        if (!currentRefineHtml.includes('<span class="refine-by-value">' +value+ '</span>')) {
          jQ('.boost-pfs-filter-refine-by-items').prepend(tagHtml);
        }    
          
            
      }
      
      if(Utils.checkExistFilterOptionParam()){
        var collectionUrl = jQ(".boost-custom-collection-tag a").attr("href");
        var queryParameters = window.location.search;
        jQ(".boost-custom-collection-tag a").attr("href" , collectionUrl + queryParameters)
      }
    }
  };


  /* start-boost-custom */
  var customSlugify = function(text){
    //var from = "ăîșțâ"; // Schimbare tag handles - 06.12.2022
    var from = "ăîâ";
    //var to = "aista"; // Schimbare tag handles - 06.12.2022
    var to = "aia";
    for (var z = 0, l = from.length; z < l; z++){
      text = text.replace(new RegExp(from.charAt(z), 'g'), to.charAt(z));
    }

    // text = text.replace(/[\s\/]+/g, '-').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '').toLowerCase().trim(); // Schimbare tag handles - 06.12.2022
    text = text.replace(/[\s\/]+/g, '-').replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '').toLowerCase().trim();
    return text;
  }
  var filterParams = FilterApi.updateParamsFromUrl;

  FilterApi.updateParamsFromUrl = function(url) {
    filterParams.call(this, url);
    /* Fix Boost #137123 */
    // if (Globals.collectionId != '39590264892') {
    //   Globals.queryParams.pf_t_show = ['pfs-show-product'];
    // }
    /* End fix Boost #137123 */
    

    if (boostPFSConfig.general.template.indexOf('new-products') > -1) {
      Globals.queryParams.pf_t_a = ['psf-new-products'];
    }

    if (boostPFSConfig.general.collection_handle.indexOf('speciale') > -1) {
      Globals.queryParams.pf_t_discount = ['pfs-discount-product'];
    }
  }

  RobotsMeta.prototype.render = function() {
    if (this.isRender()) {
      jQ('head').append(this.compileTemplate());
    }
  }

  RobotsMeta.prototype.isRender = function() {
    return false;
    /* 15.02.2022 Razvan eliminat asta si adaugat linia de mai sus la cererea lui Mihai Aperghis
    var flag = false;
    for (var k in Globals.queryParams) {
      if (k.indexOf('pf_') > -1) {
        if (k == 'pf_t_show' || k == 'pf_t_a' || k == 'pf_t_discount') {
          flag = false;
        } else {
          flag = true;
        }
      }
    }
    return Settings.getSettingValue('general.enableSeo') && flag && jQ(this.selecor.robots).length == 0;
  	*/
  }

  jQ(document).on('click', '.boost-pfs-filter-tree-mobile-button button', function() {      
    setTimeout(function() { jQ('.boost-pfs-filter-option-list .boost-pfs-filter-option-content-inner').each(function() { new SimpleBar(this); }); }, 400);        
  });

  //     FilterOptionItemMultiLevelCollections.prototype.getTemplate = function() {
  //       return '<li class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-first-level-item">' +
  // 				'<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}} boost-pfs-open">' +
  // 					'<button class="{{class.button}}" data-action="select-filter-item">' +
  // 						'<span class="boost-pfs-filter-option-value">{{label}}</span>' +
  // 					'</button>' +
  // 					'{{arrow}}' +
  // 				'</div>' +
  // 				'<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-second-level-list">' +
  // 					'{{childItems}}' +
  // 				'</div>' +
  // 			'</li>';
  //     }

  PageInfoCollection.prototype.buildDocumentInfo = function() {

    if (typeof this.collectionData !== 'undefined' && this.collectionData.hasOwnProperty('collection')) {
      var pageTitle = this.collectionData.collection.title + ' - ' + Globals.shopName;

      document.title = customPageTitle || pageTitle;
    }
  };

  // #boost-53732: custom tag page
  FilterOptionItemMultiLevelCollections.prototype.getTemplate = function() {
    return '<li class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-first-level-item"> <div class="boost-pfs-open {{class.filterOptionItem}} {{class.filterOptionLabel}}"> <a class="{{class.button}}" href="{{href}}"> <span class="boost-pfs-filter-option-value">{{label}}</span> </a> {{arrow}} </div> <div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-second-level-list"> {{childItems}} </div> </li>';
  };

  // #boost-53732: custom tag page
  FilterOptionItemSecondLevelCollections.prototype.getTemplate = function() {
    return '<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-second-level-item"> <div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}"> <a class="{{class.button}}" href="{{href}}"> <span class="boost-pfs-check-box"></span> <span class="boost-pfs-filter-option-value">{{label}}</span> </a> {{arrow}} </div> <div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-third-level-list"> {{childItems}} </div> </div>';
  };

  // #boost-53732: custom tag page
  var orgFilterRefineByRender = FilterRefineBy.prototype.render;

  FilterRefineBy.prototype.render = function() {
    orgFilterRefineByRender.call(this);
    if(Utils.isTagPage() && boostPFSAppConfig.currentTagRemoveLink != ''){
      if(this.$element == null){
        this.$element = jQ(this.compileTemplate());
        this.$refineByItemsContainer = this.$element.find('.' + Class.filterSelectedItems);
      }
      /* this.$refineByItemsContainer.prepend(boostPFSAppConfig.currentTagRemoveLink);
      if(Utils.checkExistFilterOptionParam()){
        var collectionUrl = jQ(".boost-custom-collection-tag a").attr("href");
        var queryParameters = window.location.search;
        jQ(".boost-custom-collection-tag a").attr("href" , collectionUrl + queryParameters)
      } */
    }
  };
  
  // #boost-53732: custom tag page
  FilterOptionItem.prototype.isAppliedFilter = function() {
    var filterOptionId = this.parent.filterOptionId;
    var filterType = this.parent.filterType;

    if (filterType == FilterOptionEnum.FilterType.COLLECTION) {
      if (Globals.queryParams['collection_scope'] == this.collectionId) {
        return true;
      }
    } else {
      // console.log('test', Utils.slugify(this.value));
      var values = Globals.queryParams[filterOptionId];
      if (Array.isArray(values) && values.includes(this.value) ||
          (Utils.isTagPage() && Utils.slugify(Globals.queryParams.tag[0]).includes(Utils.slugify(this.value)))) {
        return true;
      }
    }
    return false;

    // neu Globals.queryParams.tag == this.value => return true.
  };
  /* end-boost-custom */
  FilterApi.beforeCall = function(eventType, eventInfo){
    if(Utils.isTagPage() && boostPFSAppConfig.currentTagRemoveLink != ''){
      if(jQ(".boost-custom-collection-tag a").length){
        if(eventType === "clearAll"){
          window.location = boostPFSAppConfig.collectionUrl
        }
      }
    }
  }
  
  FilterOptionItem.prototype.buildLabel = function() {
		var filterOption = this.filterOption ? this.filterOption : this.parent;

		// var label = Utils.stripHtml(this.label);
        var label = Utils.unescape(this.label);
		var prefix = filterOption.prefix;

		if (typeof label != 'string') return '';

		// Remove Prefix
		if (typeof prefix == 'string') {
			prefix = prefix.replace(/\\/g, '');
			label = label.replace(prefix, '').trim();
		}

		// No capital label of Rating filter option
		if (label.indexOf('boost-pfs-filter-icon-star') > -1) return label;

		// Make the text to uppercase
		filterOption.displayAllValuesInUppercaseForm = filterOption.displayAllValuesInUppercaseForm || false;
		if (filterOption.displayAllValuesInUppercaseForm) return label.toUpperCase();

		// Make all letters lowercase first, then capitalize all first letters of each string in a filter option value
		// For example: HELLO World => Hello World
        if (Settings.getSettingValue('general.forceCapitalizeFilterOptionValues')){
          if(label.indexOf("Bucuresti-") > -1){
            var labelSpaced = label.split("-").join(" - ");
            var labelCapitalized = Utils.capitalize(labelSpaced, true);
            return labelCapitalized.split(" - ").join("-");
          }else{
            return Utils.capitalize(label, true);
          }    	
        } 

		// Make all letters lowercase first, then capitalize first letter of a filter option value
		// For example: product fILTER => Product filter
		if (Settings.getSettingValue('general.capitalizeFirstLetterFilterOptionValues')) return Utils.capitalize(label, true, true);

		// Just capitalize first letter and don't change the format of any other letters 
		// For example: hello wORLD => Hello WORLD
		if (Settings.getSettingValue('general.capitalizeFilterOptionValues')) return Utils.capitalize(label);

		// return label
		return Utils.stripHtml(label);
	};

  /* start 138414 */
  PageItem.prototype.compileTemplate = function() {
		var pageUrl = this.data.hasOwnProperty('url')? this.data.url : '#';
		var itemThumb = '';
		var itemThumbSrc = '';
		var itemExcerpt = '';

		if (this.displayImage) {
			// Get the page thumbnail url
			if (this.data.image && this.data.image.hasOwnProperty('src') && this.data.image.src !== '') {
				itemThumbSrc = Utils.optimizeImage(this.data.image.src, '200x');
			}
			// Build the page thumbnail
			if (itemThumbSrc.length > 0) {
				itemThumb = this.getTemplate(PageItemList.Enum.tempType.IMAGE);
			}
		}

        if(typeof(this.data.url) !== 'undefined' && !this.data.url.includes('/pages/')){
  		if (this.displayExcerpt && this.data.body_html && typeof this.data.body_html === 'string') {
  			let summaryHtml = Utils.stripHtml(this.data.body_html);
              if (summaryHtml.length > 264) summaryHtml = summaryHtml.substr(0, Settings.getSettingValue('search.pageExcerptLimitCharacter')) + '...';
  			itemExcerpt = this.getTemplate(PageItemList.Enum.tempType.EXCERPT).replace(/{{itemExcerpt}}/g, summaryHtml);
  		}
        }

		return this.getTemplate()
			.replace(/{{itemThumbnail}}/g, itemThumb)
			.replace(/{{itemThumbSrc}}/g, itemThumbSrc)
			.replace(/{{itemDesc}}/g, itemExcerpt)
			.replace(/{{class.filterResultItem}}/g, Class.filterResultItem)
			.replace(/{{itemUrl}}/g, pageUrl)
			.replace(/{{itemTitle}}/g, Utils.stripHtml(this.data.title));
	};
  /* end 138414 */

  // Schimbare tag handles - 06.12.2022
  FilterOptionItemSecondLevelCollections.prototype.setData = function(data) {
    this.tag = data.tag;
    this.tag = this.tag.toLowerCase().replace(/'/g, '').replace(/"/g, '');
    this.tag = this.tag.replace(/[\s\/]+/g, '-')    // Replace spaces with -
                    .replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-')   // Replace all special characters with -, except _
                    .replace(/[ăâ]/g, 'a') // by Vertify
                    .replace(/î/g, 'i') // by Vertify
                    .replace(/\-\-+/g, '-')     // Replace multiple - with single -
                    .replace(/^-+/, '')         // Trim - from start of text
                    .replace(/-+$/, '');         // Trim - from end of text
    this.slugifyTag = this.tag;
    this.label = data.displayName ? data.displayName : data.tag;
    this.filterOption = this.parent.filterOption;
    this.requestInstantly = this.parent.requestInstantly;
    this.collectionId = this.parent.collectionId;
    this.handle = this.parent.handle;
    this.level = 2;
    this.href = (!Utils.isCollectionPage() || Settings.getSettingValue('general.multiLevelCollectionSelectType') == FilterOptionEnum.SelectType.MULTIPLE) ?
      '#' : '/collections/' + this.handle + '/' + this.slugifyTag;
 
    this.sortOrder = this.parent.sortOrder ? this.parent.sortOrder : Globals.defaultSorting;
 
    this.children = [];
    if (Array.isArray(data.subTags)) {
      data.subTags.forEach(tagData => {
        if (tagData.tag) {
          var childItem = new FilterOptionItemThirdLevelCollections(this.filterTreeType);
          this.addComponent(childItem);
          childItem.setData(tagData);
        }
      })
    }
 
    // Format the label
    this.label = this.buildLabel();
    this.isSelected = this.isAppliedFilter();
    this.isSelectedChild = this.children.some(x => x.isSelected || x.isSelectedChild);
 
    this.filterOption.allNestedFilterItems.set(this.collectionId + ':' + this.tag, this);
  }

  ProductListPlaceholder.prototype.getTemplate = function() {
      return `
          <div class="{{wrapperClass}} {{class.filterProductSkeleton}}">
              <div class="{{class.filterProductSkeleton}}-image" style="padding-top: {{paddingTop}}%"></div>
              <div class="{{class.filterProductSkeleton}}-meta">
                  <span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}"></span>
                  <span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}-width1"></span>
                  <span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}-width1"></span>
                  <span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}-width1"></span>
              </div>
          </div>
      `.trim();
  }

  /* Boost 171788 */
  // Use this function when using most popular in search page
  MostPopular.prototype.setProductData = function(data) {
      let newData = data.map(item => {
          if (item.price_min === 0) {
              for (let variant of item.variants) {
                  if ((variant.price > 0 && item.price_min === 0) || (variant.price > 0 && item.price_min !== 0 && item.price_min > variant.price)) {
                      item.compare_at_price_min = variant.compare_at_price; item.price_min = variant.price; item.compare_at_price = variant.compare_at_price;
                  }
              }
          }
          return item;
      })
      this.isFetchedMostPopularData = true;
      var temp = {
          products: newData
      }
      this.setData(temp, true);
  }
  /* END Boost 171788 */
  
})();



/* Begin patch boost-010 run 2 */
Filter.prototype.beforeInit=function(){var t=this.isBadUrl();t&&(this.isInit=!0,window.location.href=window.location.pathname)},Filter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var n=0;n<t.length;n++){var i=t[n],r=(i.match(/</g)||[]).length,a=(i.match(/>/g)||[]).length,o=(i.match(/alert\(/g)||[]).length,h=(i.match(/execCommand/g)||[]).length;if(r>0&&a>0||r>1||a>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */